<dx-calendar (onValueChanged)="calendar_onValueChanged($event)">
  <!-- Templates -->
  <ng-container *dxTemplate="let data of 'cell'">
    <div [ngClass]="calendarClass(data)" [title]="calendarTitle(data)">
      {{ data.text }}
    </div>
  </ng-container>
</dx-calendar>
